/* eslint-disable no-unused-vars */
// const devApiDomain = 'https://europe-dev.dankal.cn/v1/' // 开发环境api域名
const devApiDomain = '' // 开发环境api域名

// const devExportApi = 'https://europe-dev.dankal.cn/' // 开发环境导出表格api域名
const devExportApi = '' // 本地环境导出表格api域名
const stageApiDomain = '' // 测试环境api域名
const proApiDomain = 'https://xozxcx.qingchenglive.icu' // 生产环境api域名
const devImgDomain = 'https://cdn.idalhome.com/' // 开发环境图片域名
const proImgDomain = 'https://cdn.idalhome.com/' // 生产环境图片域名

export const apiDomain = devApiDomain;

export const exportApi = devExportApi;

export const imgDomain = devImgDomain;

export const uploadDomain = 'https://upload.qiniup.com/';



// WEBPACK FOOTER //
// ./src/configs/env.js